import React, { forwardRef, useState, useContext } from "react";
import { GET_PARTIES } from "../../utils/graphQL/queries";
import { DEL_PARTY } from "../../utils/graphQL/mutations";
import { useMutation } from "@apollo/client";
import ConfirmationDialog from "../common/confirmationDialog";

export function DelParty(props, ref) {
  const {
    onClose,
    open,
    title,
    setopenAlert,
    setalertMessage,
    setloader,
    setSeverity,
  } = props;

  const [deleteParty, { loading }] = useMutation(DEL_PARTY);
  const [spinners, setSpinners] = useState(false);
  const [errorMessage, seterrorMessage] = useState(false);

  const handleDelete = async () => {
    setloader(true);
    var id = ref.current.row ? ref.current.row.id : null;
    const response = await deleteParty({
      variables: { id: id },
      refetchQueries: [{ query: GET_PARTIES }],
      awaitRefetchQueries: true,
    });
    if (response.data.deleteParty.deleted === true) {
      seterrorMessage(false);
      setSpinners(false);
      setopenAlert(true);
      setalertMessage("Party has been Deleted");
      setSeverity(true);
    } else {
      seterrorMessage(true);
      setSpinners(false);
    }
    props.onClose();
    setloader(false);
  };

  return (
    <div>
      <ConfirmationDialog
        open={open}
        handleClose={onClose}
        handleSubmit={handleDelete}
        dialogTitle="Are you sure you want to Delete Party ?"
      />
    </div>
  );
}

export default forwardRef(DelParty);
